import React, { useState, useEffect } from "react";

import Hero from "./components/landing/Hero";
import ContactStrip from "./components/landing/ContactStrip";
import Categories from "./components/landing/Categories";
import FeaturedProducts from "./components/landing/FeaturedProducts";
import Newsletter from "./components/landing/Newsletter";
import StickyMarketplaceCTA from "./components/landing/StickyMarketplaceCTA";
import Footer from "./components/landing/Footer";
import SocialBanner from "./components/landing/SocialBanner";
import Header from "./components/landing/Header";

const featuredProducts = [
  {
    name: "Premium Laundry Detergent",
    category: "Cleaning & Laundry",
    image:
      "https://res.cloudinary.com/ddxaiuefs/image/upload/v1762194316/493ef1f2-81d7-46e9-8fca-6384b9abd335_lkcfe9.jpg",
    description: "High-efficiency formula for spotless cleaning",
    price: "AED 79",
  },
  {
    name: "Luxury Body Wash Set",
    category: "Personal Hygiene",
    image:
      "https://res.cloudinary.com/ddxaiuefs/image/upload/v1762194345/d413425b-c74f-4b8b-bf5f-ebe97971004e_bzjkfe.jpg",
    description: "Moisturizing formula with natural extracts",
    price: "AED 65",
  },
  {
    name: "Baby Care Essentials Kit",
    category: "Baby & Infant Care",
    image:
      "https://res.cloudinary.com/ddxaiuefs/image/upload/v1762194353/b4b0e0ea-33d1-4ec0-af2c-9e1f4b0bb7a0_rldwcr.jpg",
    description: "Complete care package for your little one",
    price: "AED 57",
  },
  {
    name: "Premium Toilet Paper 24-Pack",
    category: "Bathroom Accessories",
    image:
      "https://res.cloudinary.com/ddxaiuefs/image/upload/v1762194357/a0361ba7-cb57-4cf3-9404-bf6a2038b190_jwlfqy.jpg",
    description: "Soft, strong, and absorbent 3-ply tissue",
    price: "AED 55",
  },
  {
    name: "Multi-Surface Cleaner",
    category: "Home Maintenance",
    image:
      "https://res.cloudinary.com/ddxaiuefs/image/upload/v1762194361/2c5ef603-4502-4f6f-a5d1-2f00e58bb05c_akddzn.jpg",
    description: "Powerful cleaning for all surfaces",
    price: "AED 38",
  },
  {
    name: "Organic Feminine Care",
    category: "Feminine Care",
    image:
      "https://res.cloudinary.com/ddxaiuefs/image/upload/v1762194362/d3edc327-359e-4d3b-a224-a131e5a0d9ae_gkcjwe.jpg",
    description: "Natural and gentle protection",
    price: "AED 42",
  },
];

const newArrivalProducts = [
  {
    name: "Floor Scrub Brush",
    category: "Home Tools",
    image: "https://m.media-amazon.com/images/I/71Nt6i99FkL._AC_SL1500_.jpg",
    description: "Easy floor cleaning system",
    price: "AED 45",
  },
  {
    name: "Floor Whiper",
    category: "Lifestyle",
    image: "https://m.media-amazon.com/images/I/71hB5TTboDL._SL1500_.jpg",
    description: "Relaxing fragrance diffuser",
    price: "AED 99",
  },
  {
    name: "DustPan & Broom",
    category: "Baby Care",
    image: "https://m.media-amazon.com/images/I/719pjV0hh4L._SL1500_.jpg",
    description: "Soft and safe wipes",
    price: "AED 25",
  },
  {
    name: "Pet cleaner",
    category: "Home Tools",
    image:
      "https://s.alicdn.com/@sc02/kf/H9b38289e90134c1ebc27e6b5ec2ac266j.jpg",
    description: "Easy floor cleaning system",
    price: "AED 45",
  },
  {
    name: "Smart Mop Cleaner",
    category: "Lifestyle",
    image: "https://m.media-amazon.com/images/I/71enZDav7cL._SL1500_.jpg",
    description: "Relaxing fragrance diffuser",
    price: "AED 99",
  },
  {
    name: "Spin Mop Cleaner",
    category: "Home Tools",
    image:
      "https://s.alicdn.com/@sc04/kf/H3a65046d2a744b53ac70bcb05a3c626aK.jpg",
    description: "Complete grooming solution for pets",
    price: "AED 89",
  },
  {
    name: "Other Cleaning Tools",
    category: "Home Tools",
    image:
      "https://m.media-amazon.com/images/I/719zFYBhI1L._AC_UF350,350_QL80_.jpg",
    description: "Soft and safe wipes",
    price: "AED 25",
  },
];

export default function Home() {
  const [showStickyCTA, setShowStickyCTA] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      setShowStickyCTA(window.scrollY > 800);
    };

    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  return (
    <div className="min-h-screen bg-gradient-to-b from-[#FAFAF9] via-white to-[#F9FAFB]">
      <Header />

      <section id="hero">
        <Hero />
      </section>

      <section id="contact">
        <ContactStrip />
      </section>

      <section id="categories">
        <Categories />
      </section>

      <section>
        <FeaturedProducts
          title="Featured Products"
          products={featuredProducts}
        />
      </section>

      {/* New Arrivals Section */}
      <section className="py-10">
        <div className="flex justify-center mt-5 mb-6">
          <img
            src="/mumed-asset.jpeg"
            alt="New Arrivals Banner"
            className="w-40 md:w-60 rounded-xl shadow-lg object-cover"
          />
        </div>

        <FeaturedProducts
          title="New Arrivals"
          subtitle="Latest products in store"
          products={newArrivalProducts}
        />
      </section>

      <section>
        <SocialBanner />
      </section>

      <section id="newsletter">
        <Newsletter />
      </section>

      <Footer />
      <StickyMarketplaceCTA show={showStickyCTA} />
    </div>
  );
}